import { useMoveToGoods } from './moveToGoods';
import { useMoveToRecentlyViewedGoods } from './moveToRecentlyViewedGoods';
import { moveToRankingGoods } from './moveToRankingGoods';

export const useGoodsNavigator = () => {
  const moveToGoods = useMoveToGoods();
  const moveToRecentlyViewedGoods = useMoveToRecentlyViewedGoods();

  return {
    moveToGoods,
    moveToRecentlyViewedGoods,
    moveToRankingGoods,
  };
};